export default "__VITE_ASSET__CpzlbDGo__"